import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { PageLoader } from "@/components/common";
import { ArrowLeft } from "lucide-react";

const OPTIONS = [
  { key: "offers", label: "Offers", desc: "New offers, counters and decisions" },
  { key: "messages", label: "Messages", desc: "New chat messages" },
  { key: "reviews", label: "Reviews", desc: "When someone rates you" },
  { key: "account", label: "Account", desc: "Account and admin notices" },
];

export default function NotificationSettings() {
  const navigate = useNavigate();
  const [prefs, setPrefs] = useState(null);
  const { data, isLoading } = useQuery({ queryKey: ["notif-prefs"], queryFn: () => apiFetch("/me/notification-prefs") });

  useEffect(() => { if (data) setPrefs(data); }, [data]);

  const toggle = async (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    try { await apiFetch("/me/notification-prefs", { method: "PUT", body: JSON.stringify(next) }); }
    catch (err) { toast.error(err.message); setPrefs(prefs); }
  };

  if (isLoading || !prefs) return <PageLoader />;

  return (
    <div className="mx-auto max-w-lg px-4 py-8 sm:px-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="rounded-full p-1.5 hover:bg-secondary"><ArrowLeft className="h-5 w-5" /></button>
        <h1 className="font-display text-xl font-extrabold">Notification settings</h1>
      </div>
      <div className="mt-6 divide-y divide-border overflow-hidden rounded-2xl border border-border">
        {OPTIONS.map((o) => (
          <div key={o.key} className="flex items-center justify-between p-4">
            <div>
              <p className="font-medium">{o.label}</p>
              <p className="text-xs text-muted-foreground">{o.desc}</p>
            </div>
            <button
              data-testid={`toggle-${o.key}`}
              onClick={() => toggle(o.key)}
              className={`relative h-6 w-11 rounded-full transition ${prefs[o.key] ? "bg-price" : "bg-border"}`}
            >
              <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-all ${prefs[o.key] ? "left-[22px]" : "left-0.5"}`} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
